import { colors, spacing } from "@/ui/tokens";

export interface ToolDividerProps {
  /** Add spacing[4] vertical margin */
  spaced?: boolean;
}

/** Subtle horizontal rule used between tool card sections. */
export function ToolDivider({ spaced }: ToolDividerProps) {
  return (
    <hr
      style={{
        border: "none",
        borderTop: `1px solid ${colors.border.subtle}`,
        margin: spaced ? `${spacing[4]}px 0` : 0,
      }}
    />
  );
}
